module.exports = __webpack_public_path__ + "media/images/ntt-research-logo-white-adb636527352f814d30a176f974d6aef.svg";